<template>
  <NewListItem :href="forumItem.url">
    <template v-slot:image>
      <v-icon size="32px">{{ mdiCalendar() }}</v-icon>
    </template>

    <template v-slot:title>
      <a :href="forumItem.url">
        {{ forumItem.title }}
        <strong>
          {{
            formatToDateSpanLong(
              forumItem.details.start_at,
              forumItem.details.end_at
            )
          }}</strong
        >
        <AccessIcon
          v-if="forumItem.nonmember_access !== 'write'"
          :itemType="forumItem.forum_item_type"
          :isMemberInGroup="forumItem.is_member"
          :groupName="forumItem.group_name"
          :nonmemberAccess="forumItem.nonmember_access"
          :hidden="forumItem.group.type === 'PrivateGroup'"
          size="1.14285714rem"
        />
        <v-tooltip bottom v-if="forumItem.mailed_at" max-width="350px">
          <span>{{ t$(".mailed_at_tooltip") }}</span>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-on="on"
              v-bind="attrs"
              class="ml-2"
              color="primary"
              size="1.14285714rem"
              style="rotate: -45deg; margin-top: -8px"
            >
              {{ mdiSend() }}
            </v-icon>
          </template>
        </v-tooltip>
      </a>
      <v-chip
        class="mobile hidden"
        v-for="tag in forumItem.tags"
        :key="tag"
        :href="tag.url"
        link
        outlined
        x-small
        label
        style="
          text-transform: uppercase;
          font-weight: 900 !important;
          font-size: 10px;
          padding: 2.83px 5.33px;
          letter-spacing: 0.5px;
        "
      >
        {{ tag.name }}
      </v-chip>
    </template>

    <template v-slot:meta-columns>
      <div>
        <Label :url="forumItem.group_url">
          <slot name="icon" v-if="forumItem.level_id">
            <ConnectIcon
              v-if="forumItem.level_id"
              :tooltip="t$('.level_tooltip').toString()"
              size="12"
              color="white"
            />
          </slot>
          {{ forumItem.group_name }}
        </Label>
      </div>
      <div>
        <v-icon size="18">{{ mdiCalendarCheck() }}</v-icon>
        <span class="text ellipsis">
          <strong>{{
            forumItem.details.attends_count + forumItem.details.guests_count
          }}</strong>
          Anmeldungen
        </span>
      </div>
      <div>
        <v-icon size="18">{{ mdiClockTimeFourOutline() }}</v-icon>
        <template v-if="forumItem.latest_post_at">
          Letzte Antwort:
          {{ moment(forumItem.latest_post_at).fromNow() }}
          von
          <template v-if="forumItem.latest_post_by.profile_visible">
            <a :href="forumItem.latest_post_by.url" @click.stop>
              {{ getContextName(forumItem, forumItem.latest_post_by) }}
            </a>
          </template>
          <template v-else>
            {{ getContextName(forumItem, forumItem.latest_post_by) }}
          </template>
        </template>
        <template v-else>
          Erstellt
          {{ moment(forumItem.created_at).fromNow() }}
          von
          <template v-if="forumItem.creator.profile_visible">
            <a :href="forumItem.creator.url" @click.stop>
              {{ getContextName(forumItem, forumItem.creator) }}
            </a>
          </template>
          <template v-else>
            {{ getContextName(forumItem, forumItem.creator) }}
          </template>
        </template>
      </div>
    </template>

    <template v-slot:actions> </template>
  </NewListItem>
</template>

<script lang="ts">
import { defineComponent, PropType, Ref, toRefs } from "vue"
import AccessIcon from "features/common/ui/AccessIcon.vue"
import { ForumItem } from "suus-api"
import MemberLink from "components/MemberLink.vue"
import RelativeTime from "components/UI/RelativeTime.vue"
import ConnectIcon from "components/icons/ConnectIcon.vue"
import ListItem from "components/ListItem.vue"
import {
  mdiCalendar,
  mdiClockTimeFourOutline,
  mdiCalendarCheck,
  mdiSend,
} from "@mdi/js"
import useTranslate from "features/common/translate/concerns/useTranslate"
import { getContextName, getContextNameLong } from "concerns/useContextName"
import moment from "moment"
import NewListItem from "components/NewListItem.vue"
import { formatToDateSpanLong } from "app/util/date.helper"
import Label from "app/ui-primitives/text/Label.vue"
export default defineComponent({
  name: "ForumEvent",
  computed: {
    moment() {
      return moment
    },
  },
  methods: {
    getContextName,
    formatToDateSpanLong,
    getContextNameLong,
    mdiCalendarCheck() {
      return mdiCalendarCheck
    },
    mdiClockTimeFourOutline() {
      return mdiClockTimeFourOutline
    },
    mdiSend() {
      return mdiSend
    },
    mdiCalendar() {
      return mdiCalendar
    },
  },
  components: {
    Label,
    NewListItem,
    ListItem,
    ConnectIcon,
    RelativeTime,
    MemberLink,
    AccessIcon,
  },
  props: {
    forumItem: Object as PropType<ForumItem>,
    minimal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { forumItem } = toRefs(props)
    const { t$ } = useTranslate("forum_topics.forum_topic")
    const timeago = (date: string) => date
    return {
      forumItem: forumItem as Ref<ForumItem>,
      timeago,
      t$,
    }
  },
})
</script>

<style scoped></style>
